import ubug from "..\\..\\..\\..\\content\\assets\\logos\\ubug5.svg";
import ubug_avatar from "..\\..\\..\\..\\content\\assets\\head-avatar.jpg";
import React from 'react';
export default {
  ubug,
  ubug_avatar,
  React
};